var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptopChecks0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clss-1{fill:none;stroke:#505050;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop_checks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clss-1",
    d: "M47,29H29l-2,2H22l-3-2H1v2a4,4,0,0,0,4,4H43a4,4,0,0,0,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clss-1",
    d: "M44,29V3a2,2,0,0,0-2-2H6A2,2,0,0,0,4,3V29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "clss-1",
    points: "12 8 14 10 18 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "clss-1",
    points: "12 15 14 17 18 13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "clss-1",
    points: "12 22 14 24 18 20"
  }), /*#__PURE__*/React.createElement("line", {
    className: "clss-1",
    x1: 21,
    y1: 8,
    x2: 35,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "clss-1",
    x1: 21,
    y1: 15,
    x2: 35,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "clss-1",
    x1: 21,
    y1: 22,
    x2: 35,
    y2: 22
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopChecks0);
export default __webpack_public_path__ + "static/media/laptop-checks_0.728cb770cdd86c998f2bab41bd5d9d7f.svg";
export { ForwardRef as ReactComponent };